export default __webpack_public_path__ + "static/media/aimasterclass-banner.d49babf7753175e35bdceda9454ee99d.png";